<template>
  <tbody class="is-editable">
    <tr>
      <td class="c-table__cell--center c-table__cell--middle is-next" colspan="1" @click="onShowClick">
        <div class="c-cell">
          <p class="date">{{ summaryMessage.summary_date }}</p>
        </div>
      </td>
      <td class="c-table__cell--center c-table__cell--middle">
        {{ summaryMessage.message.message_name }}
      </td>
      <td class="c-table__cell--center c-table__cell--middle">
        {{ summaryMessage.display_count }}
      </td>
      <td class="c-table__cell--center c-table__cell--middle">
        {{ summaryMessage.click_count }}
      </td>
      <td class="c-table__cell--center c-table__cell--middle">
        {{ ctr }}
      </td>
      <td class="c-table__cell--center c-table__cell--middle">
        {{ sendStartDate }}
      </td>
      <td class="c-table__cell--center c-table__cell--middle">
        {{ sendEndDate }}
      </td>
    </tr>
  </tbody>
</template>

<script>
export default {
  props: {
    summaryMessage: Object,
  },
  emits: ["show-click"],
  computed: {
    ctr: function () {
      let ctrString = '0.00%';
      if(this.summaryMessage.display_count > 0 && this.summaryMessage.click_count > 0){
        let ctr = this.summaryMessage.click_count * 100 / this.summaryMessage.display_count;
        ctrString = ctr.toFixed(2) + '%';
      }
      return ctrString;
    },
    sendStartDate: function () {
      let sendStartDate = '-';
      if(this.summaryMessage){
        if(this.summaryMessage.message){
          if(this.summaryMessage.message.message_deliver){
            if(this.summaryMessage.message.message_deliver.send_start_date){
              sendStartDate = this.summaryMessage.message.message_deliver.send_start_date;
            }
          }
        }
      }
      return sendStartDate;
    },
    sendEndDate: function () {
      let sendEndDate = '-';
      if(this.summaryMessage){
        if(this.summaryMessage.message){
          if(this.summaryMessage.message.message_deliver){
            if(this.summaryMessage.message.message_deliver.send_end_date){
              sendEndDate = this.summaryMessage.message.message_deliver.send_end_date;
            }
          }
        }
      }
      return sendEndDate;
    },
  },
  methods: {
    onShowClick: function () {
      this.$emit('show-click',this.summaryMessage);
    },
  },

};
</script>
